module.exports = __webpack_public_path__ + "assets/parents-unselected.db30f837b60db618dd2cde3f9dfc2be7.svg";